import { EEventStatus, EEventStatusLabel } from 'entities/Events/Event.enum';

export const getDashboardEventListRadioOptions = () => {
  return [EEventStatus.Inbox, EEventStatus.UnderReview, EEventStatus.Completed].map((status) => {
    return {
      label: EEventStatusLabel[status],
      value: status,
    };
  });
};
